module.exports = __webpack_public_path__ + "static/media/bus-school.b6c91630.svg";